import { Container, Grid, Paper, ListItem, ListItemIcon, List, ListItemText, ListItemAvatar, Avatar, Typography, CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { green, red } from '@mui/material/colors'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import IconButton from '@mui/material/IconButton';
import SyncIcon from '@mui/icons-material/Sync';
import ErrorIcon from '@mui/icons-material/Error';
import React, { useState, useEffect } from "react";
import { getServiceHealthEast, getServiceHealthWest } from "../../api/healthcheck";
import awsLambdaLogo from '../../assets/Amazon_Lambda_Logo.png'
import awsDynamoDBLogo from '../../assets/Amazon_DynamoDB_Logo.png'
import awsS3Logo from '../../assets/Amazon_S3_Logo.png'
import awsSNSLogo from '../../assets/Amazon_SNS_Logo.png'
import awsSESLogo from '../../assets/Amazon_SES_Logo.png'
import {  } from "../../util/constants";
import { copyJsonObject, isObjectEmpty } from '../../util/commonUtils'
import { AWS_EAST_HEALTHCHECK_API_LIST, AWS_REGIONS,SYSTEM_HEALTH_SUBTITLE, US_EAST_HEADER_LABEL, US_WEST_HEADER_LABEL } from "../../util/constants";
const useStyles = makeStyles((theme) => ({
  outerContainer: {
    [theme.breakpoints.down("md")]: {
      width: '90%',
      paddingBottom: '10%'
    },
    width: '45%',
    padding: '10px'
  },
  systemHealthBox: {
    [theme.breakpoints.down("md")]: {
      paddingBottom: '7%'
    },
    borderRadius: 10,
    padding: '20px'
  },
  healthCheckTable: {
    [theme.breakpoints.down("md")]: {
      marginLeft: '5px',
      marginTop: '10px',
      width: '100%'
    },
    borderRadius: 10,
    marginLeft: '25px',
    marginTop: '20px',
    width: '80%'
  },
  listItem: {
    borderRadius: '10px'
  },
  listItemText: {
    [theme.breakpoints.down("md")]: {
      fontSize: '13px',
    },
    fontSize: '16px',
    fontWeight: 'bold'
  },
  headerBox: {
    display: 'flex', 
    alignItems: 'center',
    flexDirection: 'column' 
  },
  headerText: {
    [theme.breakpoints.down("md")]: {
      fontSize: '18px',
    },
    fontSize: '20px',
    fontWeight: 'bold',
    textAlign: 'center', 
    flex: '1' 
  },
  checkCircleIcon: {
    [theme.breakpoints.down("md")]: {
      width: '35%'
    },
    color: green[500]
  },
  cancelIcon: {
    [theme.breakpoints.down("md")]: {
      width: '35%'
    },
    color: red[500]
  },
  overallHealthItem: {
    [theme.breakpoints.down("md")]: {
      marginLeft: '5px'
    },
    marginLeft: '40px'
  },
}));

const serviceDetails = {
  'ddb': { text: 'DynamoDB', imageUrl: awsDynamoDBLogo },
  's3': { text: 'S3', imageUrl: awsS3Logo },
  'lambda': { text: 'Lambda', imageUrl: awsLambdaLogo },
  'sns': { text: 'SNS', imageUrl: awsSNSLogo },
  'ses': { text: 'SES', imageUrl: awsSESLogo }
};

const defaultServiceHealth = [
  { name: "ddb", health: false, isDataLoading: true, errorLoadingData: false },
  { name: "s3", health: false, isDataLoading: true, errorLoadingData: false },
  { name: "lambda",health: true, isDataLoading: false, errorLoadingData: false },
  { name: "sns", health: false, isDataLoading: true, errorLoadingData: false },
  { name: "ses", health: false, isDataLoading: true, errorLoadingData: false }
];



const HealthCheck = (props) => {
  const classes = useStyles();

  const [serviceHealthListInEast, setServiceHealthListInEast] = useState(copyJsonObject(defaultServiceHealth));
  const [serviceHealthListInWest, setServiceHealthListInWest] = useState(copyJsonObject(defaultServiceHealth));
  const [eastOverallHealth, setEastOverallHealth] = useState(false);
  const [westOverallHealth, setWestOverallHealth] = useState(false);
  const [isEastOverallHealthLoading, setIsEastOverallHealthLoading] = useState(true);
  const [isWestOverallHealthLoading, setIsWestOverallHealthLoading] = useState(true);
  const [isErrorLoadingEastOverallHealth, setIsErrorLoadingEastOverallHealth] = useState(false);
  const [isErrorLoadingWestOverallHealth, setIsErrorLoadingWestOverallHealth] = useState(false);
  const [lastUpdatedAt, setLastUpdatedAt] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const refreshInterval = (process.env.DEFAULT_SYSTEM_HEALTH_AUTO_REFRESH_INTRVAL_MINS || 5) * 60 * 1000; // 5 minutes in milliseconds

  const awsServices = Object.keys(AWS_EAST_HEALTHCHECK_API_LIST);
  
  useEffect(() => {
    fetchHealthData(); // Initial data load and timestamp update

    const refreshTimer = setInterval(handleRefresh, refreshInterval); // Auto refresh
    
    return () => { 
      clearInterval(refreshTimer); // Clean up the timer when the component unmounts
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const handleRefresh = () => {
    console.log('refreshing')
    setIsRefreshing(true);
    fetchHealthData();
  };

  const isRegionEast = (region) => {
    return region === AWS_REGIONS.EAST;
  };

  const determineEastOverallHealth = () => {
    for (var i = 0; i < serviceHealthListInEast.length; i++) {
      if (serviceHealthListInEast[i].errorLoadingData) {
        setIsErrorLoadingEastOverallHealth(true);
        setIsEastOverallHealthLoading(false);
        return;
      } else if (serviceHealthListInEast[i].health) {
        continue;
      } else {
        setEastOverallHealth(false)
        setIsEastOverallHealthLoading(false);
        return;
      }
    }
    setEastOverallHealth(true);
    setIsEastOverallHealthLoading(false);
  };

  const determineWestOverallHealth = () => {
    for (var i = 0; i < serviceHealthListInWest.length; i++) {
      if (serviceHealthListInWest[i].errorLoadingData) {
        setIsErrorLoadingWestOverallHealth(true);
        setIsWestOverallHealthLoading(false);
        return;
      } else if (serviceHealthListInWest[i].health) {
        continue;
      } else {
        setWestOverallHealth(false)
        return;
      }
    }
    setWestOverallHealth(true);
    setIsWestOverallHealthLoading(false);
  };

  const updateServiceHealthByRegion = (serviceName, region, fetchResult) => {
    const serviceHealth = isObjectEmpty(fetchResult) ? null : fetchResult[serviceName];
    if (isRegionEast(region)) {
      let eastList = serviceHealthListInEast.map((service) => {
        if(service.name === serviceName) {
          service.health = serviceHealth;
          service.isDataLoading = false;
          service.errorLoadingData = !serviceHealth;
        } 
        return service;
      });
      setServiceHealthListInEast(copyJsonObject(eastList));
    } else {
      let westList = serviceHealthListInWest.map((service) => {
        if(service.name === serviceName) {
          service.health = serviceHealth;
          service.isDataLoading = false;
          service.errorLoadingData = !serviceHealth;
        } 
        return service;
      });
      setServiceHealthListInWest(copyJsonObject(westList));
    }
  };

  const fetchEastHealthDataByService = (serviceName, region) => {
    getServiceHealthEast(serviceName)
      .then((res) => res.json())
      .then((result) => {
        updateServiceHealthByRegion(serviceName, region, result);
        determineEastOverallHealth();
      })
      .catch((error) => {
        updateServiceHealthByRegion(serviceName, region, {});
        determineEastOverallHealth();
        console.log(error);
      });
  };

  const fetchWestHealthDataByService = (serviceName, region) => {
    getServiceHealthWest(serviceName)
      .then((res) => res.json())
      .then((result) => {
        updateServiceHealthByRegion(serviceName, region, result);
        determineWestOverallHealth();
      })
      .catch((error) => {
        updateServiceHealthByRegion(serviceName, region, {});
        determineWestOverallHealth();
        console.log(error);
      });
  };

  const fetchHealthData = () => {
    awsServices.map((service) => {
      fetchEastHealthDataByService(service, AWS_REGIONS.EAST);
      fetchWestHealthDataByService(service, AWS_REGIONS.WEST);
      return service;
    })

    setLastUpdatedAt(new Date()); // Update the lastUpdated timestamp
    setIsRefreshing(false);

  };

  

  const renderListItemByRegion = (serviceName, region, index) => {
    const serviceHealthList = isRegionEast(region) ? serviceHealthListInEast: serviceHealthListInWest;
    
    let currentServiceHealth = {};
    for (let i=0; i<serviceHealthList.length; i++) { // get service health details
      if (serviceHealthList[i].name === serviceName) {
        currentServiceHealth = serviceHealthList[i];
      }
    }
     
    const serviceTextAndLogo = serviceDetails[serviceName];
    return (
      <ListItem key={index} className={classes.listItem}>
        <ListItemIcon>
          {currentServiceHealth.isDataLoading ? <CircularProgress size={24} /> : currentServiceHealth.errorLoadingData ? <ErrorIcon /> : currentServiceHealth.health ? (
            <CheckCircleIcon className={classes.checkCircleIcon} />
          ) : (
            <CancelIcon className={classes.cancelIcon} />
          )
          }
        </ListItemIcon>

        <ListItemAvatar>
          <Avatar src={serviceTextAndLogo.imageUrl} alt={`Image for ${serviceTextAndLogo.text}`} style={{ width: '30px', height: '30px' }} />
        </ListItemAvatar>

        <ListItemText
          primary={
            <Typography variant="body1" className={classes.listItemText}>
              {serviceTextAndLogo.text}
            </Typography>
          }
        />
      </ListItem>
    )
  };

  const renderHealthTableByRegion = (region) => {
    return (
      <Paper elevation={3} className={classes.healthCheckTable}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <List>
              {
              awsServices.map((service, index) => renderListItemByRegion(service, region, index))
              }
            </List>
          </Grid>
        </Grid>
      </Paper>
    );
  };

  const getOverallHealthDetailsByRegion = (region) => {
    if (isRegionEast(region)) {
      return {isLoading: isEastOverallHealthLoading, overallHealthByRegion: eastOverallHealth, errorLoading: isErrorLoadingEastOverallHealth, label: US_EAST_HEADER_LABEL};
    } else {
      return {isLoading: isWestOverallHealthLoading, overallHealthByRegion: westOverallHealth, errorLoading: isErrorLoadingWestOverallHealth,  label: US_WEST_HEADER_LABEL}
    }
  };

  const renderOverallHealthByRegion = ( region) => {
    const {isLoading, overallHealthByRegion, errorLoading, label} = getOverallHealthDetailsByRegion(region)
    
    return (
      <Grid container justifyContent="center" alignItems="center">
        <ListItem className={classes.overallHealthItem}>
          <ListItemIcon>
            {isLoading ? <CircularProgress size={24}/> :  errorLoading ? <ErrorIcon/> : (overallHealthByRegion ? (
              <CheckCircleIcon className={classes.checkCircleIcon} />
            ) : (
              <CancelIcon className={classes.cancelIcon} />
            ))
            }
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="body1" className={classes.listItemText}>
                {label}
              </Typography>
            }
          />
        </ListItem>
      </Grid>
    );
  };

  const renderHeader = () => {
    return (
      <div>
        <div className={classes.headerBox}>
          <Typography variant="h6" className={classes.headerText} gutterBottom>
            {SYSTEM_HEALTH_SUBTITLE}
          </Typography>
          <Typography variant="body2" style={{ fontStyle: 'italic', fontSize: '12px' }}>
            Last Updated: {lastUpdatedAt ? lastUpdatedAt.toLocaleString() : 'Never'}
          </Typography>
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>

          {isRefreshing ? <CircularProgress size={24} /> : <IconButton onClick={handleRefresh}>
            <SyncIcon />
            <Typography variant="body2" style={{ fontSize: '12px' }}>
              Refresh
            </Typography>
          </IconButton>}

        </div>
      </div>
    );
  };

  const renderContent = () => {
    return (
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid item xs={10} sm={6}>
          {renderOverallHealthByRegion(AWS_REGIONS.EAST)}
          {renderHealthTableByRegion(AWS_REGIONS.EAST)}

        </Grid>
        <Grid item xs={10} sm={6}>
          {renderOverallHealthByRegion(AWS_REGIONS.WEST)}
          {renderHealthTableByRegion(AWS_REGIONS.WEST)}

        </Grid>
      </Grid>
    );
  };

  return (
    <Container maxWidth="md" className={classes.outerContainer}>
      <Paper elevation={3} className={classes.systemHealthBox}>
        {renderHeader()}
        {renderContent()}
      </Paper>
    </Container>
  );
};



export default HealthCheck;
